import {Injectable} from '@angular/core';
import {PriceChangesService} from '../../../prices-view/services/price-changes.service';
import {DatePipe} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class TableChartsService {

  constructor(
    private priceChangeService: PriceChangesService,
    private datePipe: DatePipe) {
  }

  public generateGraphData(value: Array<any>, visibleColumns: Array<string>, isChangelog?: boolean) {
    const result = [];

    if (value && value.length > 0) {

      if (isChangelog) {
        this.generateChangelogGraphData(value, result);

        return result;
      } else {
        this.generateBarChartGraphData(value, visibleColumns, result);
      }
    }

    let stringResult = JSON.stringify(result);
    stringResult = stringResult.replace(/null/g, '0');

    return JSON.parse(stringResult);
  }

  private generateBarChartGraphData(value: Array<any>, visibleColumns: Array<string>, result) {
    let index = 1;

    value.forEach(row => {
      const graphRow = {
        name: index + '. ' + row['Country_name'] + ' ' + row['Manufacturer'] + ' ' +
          '' + row['International_Brand_Name'] + ' ' + row['Strength'] + ' ' + row['Package_size'] + ' [' + row['Loc_Currency'] + ']',
        series: []
      };

      const series = [];

      if (row.hasOwnProperty('ExF_excl_VAT_unit') && !isNaN(row['ExF_excl_VAT_unit'])) {
        if (visibleColumns.indexOf('ExF_excl_VAT_unit') !== -1) {
          series.push({
            'name': 'Ex-Factory list price',
            'value': Number.parseFloat(row['ExF_excl_VAT_unit']),
            'color': '#0068b3'
          });
        }

        if (visibleColumns.indexOf('WHS_excl_VAT_unit') !== -1) {
          series.push(
            {
              'name': 'Wholesale price',
              'value': Number.parseFloat(row['WHS_excl_VAT_unit']),
              'color': '#cfe8d8'
            });
        }

        if (visibleColumns.indexOf('Ret_excl_VAT_unit') !== -1) {
          series.push({
            'name': 'Pharmacy price without VAT',
            'value': Number.parseFloat(row['Ret_excl_VAT_unit']),
            'color': '#ff0000'
          });
        }

        if (visibleColumns.indexOf('Ret_incl_VAT_unit') !== -1) {
          series.push({
            'name': 'Pharmacy price with VAT',
            'value': Number.parseFloat(row['Ret_incl_VAT_unit']),
            'color': '#ff9f3e'
          });
        }
      } else if (row.hasOwnProperty('Net_ExFactory_price') && !isNaN(row['Net_ExFactory_price'])) {
        if (visibleColumns.indexOf('ExF_excl_VAT') !== -1) {
          series.push({
            'name': 'Ex-Factory list price',
            'value': Number.parseFloat(row['ExF_excl_VAT']),
            'color': '#0068b3'
          });
        }

        if (visibleColumns.indexOf('Net_ExFactory_price') !== -1) {
          series.push({
            'name': 'Public Ex-factory net price',
            'value': Number.parseFloat(row['Net_ExFactory_price']),
            'color': '#cfe8d8'
          });
        }

        if (visibleColumns.indexOf('Hospital_price') !== -1) {
          series.push({
            'name': 'Hospital Price',
            'value': Number.parseFloat(row['Hospital_price']),
            'color': '#ff0000'
          });
        }

        if (visibleColumns.indexOf('Tender_ExFactory_price') !== -1) {
          series.push({
            'name': 'Tender Net Price',
            'value': Number.parseFloat(row['Tender_ExFactory_price']),
            'color': '#ff9f3e'
          });
        }

        // PRICE CHANGES CHART
      } else if (row.hasOwnProperty('ExF_excl_VAT_from') && !isNaN(row['ExF_excl_VAT_from'])) {
        const dateFrom = this.datePipe.transform(this.priceChangeService.dateFrom, 'yyyy-MM-dd');
        const dateTo = this.datePipe.transform(this.priceChangeService.dateTo, 'yyyy-MM-dd');

        if (visibleColumns.indexOf('ExF_excl_VAT_from') !== -1) {
          series.push({
            'name': 'Ex-Factory list price at ' + dateFrom,
            'value': Number.parseFloat(row['ExF_excl_VAT_from']),
            'color': '#0068b3'
          });
        }
        if (visibleColumns.indexOf('ExF_excl_VAT_to') !== -1) {
          series.push({
            'name': 'Ex-Factory list price at ' + dateTo,
            'value': Number.parseFloat(row['ExF_excl_VAT_to']),
            'color': '#0068b3'
          });
        }

        if (visibleColumns.indexOf('WHS_excl_VAT_from') !== -1) {
          series.push({
            'name': 'Wholesale price at ' + dateFrom,
            'value': Number.parseFloat(row['WHS_excl_VAT_from']),
            'color': '#cfe8d8'
          });
        }
        if (visibleColumns.indexOf('WHS_excl_VAT_to') !== -1) {
          series.push({
            'name': 'Wholesale price at ' + dateTo,
            'value': Number.parseFloat(row['WHS_excl_VAT_to']),
            'color': '#cfe8d8'
          });
        }

        if (visibleColumns.indexOf('Ret_excl_VAT_from') !== -1) {
          series.push({
            'name': 'Pharmacy price without VAT at ' + dateFrom,
            'value': Number.parseFloat(row['Ret_excl_VAT_from']),
            'color': '#ff0000'
          });
        }
        if (visibleColumns.indexOf('Ret_excl_VAT_to') !== -1) {
          series.push({
            'name': 'Pharmacy price without VAT at ' + dateTo,
            'value': Number.parseFloat(row['Ret_excl_VAT_to']),
            'color': '#ff0000'
          });
        }


        if (visibleColumns.indexOf('Ret_incl_VAT_from') !== -1) {
          series.push({
            'name': 'Pharmacy price with VAT at ' + dateFrom,
            'value': Number.parseFloat(row['Ret_incl_VAT_from']),
            'color': '#ff9f3e'
          });
        }
        if (visibleColumns.indexOf('Ret_incl_VAT_to') !== -1) {
          series.push({
            'name': 'Pharmacy price with VAT at ' + dateTo,
            'value': Number.parseFloat(row['Ret_incl_VAT_to']),
            'color': '#ff9f3e'
          });
        }
      } else {
        if (visibleColumns.indexOf('ExF_excl_VAT') !== -1) {
          series.push({
            'name': 'Ex-Factory list price',
            'value': Number.parseFloat(row['ExF_excl_VAT']),
            'color': '#0068b3'
          });
        }

        if (visibleColumns.indexOf('WHS_excl_VAT') !== -1) {
          series.push(
            {
              'name': 'Wholesale price',
              'value': Number.parseFloat(row['WHS_excl_VAT']),
              'color': '#cfe8d8'
            });
        }

        if (visibleColumns.indexOf('Ret_excl_VAT') !== -1) {
          series.push({
            'name': 'Pharmacy price without VAT',
            'value': Number.parseFloat(row['Ret_excl_VAT']),
            'color': '#ff0000'
          });
        }

        if (visibleColumns.indexOf('Ret_incl_VAT') !== -1) {
          series.push({
            'name': 'Pharmacy price with VAT',
            'value': Number.parseFloat(row['Ret_incl_VAT']),
            'color': '#ff9f3e'
          });
        }
      }

      graphRow.series = series;
      result.push(graphRow);

      index++;
    });
  }

  private generateChangelogGraphData(value: Array<any>, result) {
    const skuIDs = new Set();
    let dates: any = new Set();
    let index = 1;

    value.forEach(row => {
      dates.add(row['Price_date']);
      skuIDs.add((row['SKU_id']));
    });

    dates = Array.from(dates).sort();

    skuIDs.forEach(skuId => {
      const entriesGroupedBySkuId = value.filter(r => r['SKU_id'] === skuId);
      const countriesFromSkuGroups = new Set<string>();

      entriesGroupedBySkuId.forEach(r => countriesFromSkuGroups.add(r['Country_name']));

      countriesFromSkuGroups.forEach(countryName => {
        const series = [];
        const entriesByCountryName = entriesGroupedBySkuId.filter(r => r['Country_name'] === countryName);

        dates.forEach((date: number) => {
          const formattedDate = this.datePipe.transform(date, 'yyyy-MM-dd');
          const foundByDate = entriesByCountryName.find(e => e['Price_date'] === date);

          if (foundByDate) {
            series.push({
              name: formattedDate,
              value: foundByDate['ExF_excl_VAT']
            });
          } else {
            if (series.length > 0) {
              series.push({
                name: formattedDate,
                value: series[series.length - 1].value
              });
            }
            else {
              series.push({
                name: formattedDate,
                value: 0
              });
            }
          }
        });

        const row = entriesGroupedBySkuId[0];
        const name = index + '. ' + row['Country_name'] + ' ' + row['Manufacturer'] + ' ' +
          '' + row['International_Brand_Name'] + ' ' + row['Strength'] + ' ' + row['Package_size'] + ' [' + row['Loc_Currency'] + ']';

        result.push({
          name: name,
          series: series
        });

        index++;

      });
    });
  }
}
